<template>
  <div class="result">
    <img class="result-image" :src="src" alt="img">

    <div class="result-text">
      {{ text }}
    </div>

    <div class="md-result-button">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',

  props: {
    text: {
      type: String,
      default: ''
    },

    src: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.result {
  width: 100%;
  text-align: center;
}

.result-image {
  margin-bottom: 24px;
  height: 270px;
}

.result-text {
  margin: 0 auto 108px auto;
  max-width: 600px;
  font-size: 24px;
  line-height: 36px;
  color: #b2b2b2;
}
</style>
